<div class="main_track-guide">
  <div class="content">
    <div class="text1">Localiza en LoggiApp</div>
    <p class="subtitle-main">Encuentra rápidamente un servicio, vehículo o usuario</p>

    <div class="sections-wrapper" [ngClass]="'cols-' + visibleSectionsCount">

      <!-- Sección 1: Cargas -->
      <section class="search-card" *ngIf="showCargoSection">
        <div class="card-header">
          <i class="fas fa-truck card-header-icon"></i>
          <div class="card-titles">
            <h3>Servicios</h3>
            <span class="card-subtitle">Busca por ID {{showManifestSection ? 'o manifiesto' : ''}}</span>
          </div>
        </div>

        <div class="field-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>ID del servicio</mat-label>
            <input matInput type="text" [formControl]="cargoId" onlyNumbersInt maxlength="8" placeholder="Ej. 12345678"
              (keyup.enter)="searchCargoById()">
            <i class="fas fa-tag field-icon-suffix" matSuffix></i>
            <mat-error *ngIf="cargoId.errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <button mat-raised-button class="bg-color-primary search-btn" type="button" [disabled]="searchingCargoId"
            (click)="searchCargoById()">
            {{ searchingCargoId ? 'Buscando...' : 'Buscar por ID' }}
          </button>
        </div>

        <div class="divider" *ngIf="showManifestSection"><span>o</span></div>

        <div class="field-group" *ngIf="showManifestSection">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Manifiesto</mat-label>
            <input matInput type="text" [formControl]="cargoManifest" placeholder="N° de manifiesto"
              (keyup.enter)="searchCargoByManifest()">
            <i class="fas fa-file-alt field-icon-suffix" matSuffix></i>
            <mat-error *ngIf="cargoManifest.errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
          </mat-form-field>
          <button mat-raised-button class="bg-color-primary search-btn" type="button" [disabled]="searchingManifest"
            (click)="searchCargoByManifest()">
            {{ searchingManifest ? 'Buscando...' : 'Buscar por manifiesto' }}
          </button>
        </div>
      </section>

      <!-- Sección 2: Vehículos -->
      <section class="search-card" *ngIf="showVehicleSection">
        <div class="card-header">
          <i class="fas fa-car card-header-icon"></i>
          <div class="card-titles">
            <h3>Vehículos</h3>
            <span class="card-subtitle">Busca por placa</span>
          </div>
        </div>

        <div class="field-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Placa</mat-label>
            <input matInput type="text" [formControl]="vehiclePlate" appLicensePlate maxlength="7"
              placeholder="Ej. ABC123" (keyup.enter)="searchVehicle()">
            <i class="fas fa-map-pin field-icon-suffix" matSuffix></i>
            <mat-error *ngIf="vehiclePlate.errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
            <mat-error *ngIf="vehiclePlate.errors?.maxlength">
              {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'Placa', 8) }}
            </mat-error>
          </mat-form-field>
          <button mat-raised-button class="bg-color-primary search-btn" type="button" [disabled]="searchingVehicle"
            (click)="searchVehicle()">
            {{ searchingVehicle ? 'Buscando...' : 'Buscar vehículo' }}
          </button>
        </div>
      </section>

      <!-- Sección 3: Usuarios -->
      <section class="search-card" *ngIf="showUserSection">
        <div class="card-header">
          <i class="fas fa-user card-header-icon"></i>
          <div class="card-titles">
            <h3>Usuarios</h3>
            <span class="card-subtitle">Busca por cédula</span>
          </div>
        </div>

        <div class="field-group">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Cédula</mat-label>
            <input matInput type="text" [formControl]="userDocument" onlyNumbersInt maxlength="15"
              placeholder="N° de cédula" (keyup.enter)="searchUser()">
            <i class="fas fa-id-card field-icon-suffix" matSuffix></i>
            <mat-error *ngIf="userDocument.errors?.required">
              {{ utils.giveMessageError('MANDATORY_FIELD') }}
            </mat-error>
            <mat-error *ngIf="userDocument.errors?.maxlength">
              {{ utils.giveMessageError('MAX_LENGTH_EXCEED', 'Cédula', 20) }}
            </mat-error>
          </mat-form-field>
          <button mat-raised-button class="bg-color-primary search-btn" type="button" [disabled]="searchingUser"
            (click)="searchUser()">
            {{ searchingUser ? 'Buscando...' : 'Buscar usuario' }}
          </button>
        </div>
      </section>

    </div>
  </div>
</div>